

























import { Component } from 'vue-property-decorator';
import { requiredIf } from 'vuelidate/lib/validators';
import { RuleDecl } from 'vue/types/options';
import { State } from 'vuex-class';
import Location from '@/services/Location';
import Vue from 'vue';

import HoursAtm from './HoursAtm.vue';
import HoursDriveThrough from './HoursDriveThrough.vue';
import HoursLobby from './HoursLobby.vue';


@Component({
	components: { 
		HoursAtm,
		HoursDriveThrough,
		HoursLobby,
	},
})
export default class Hours extends Vue {
	@State('location') location!: Location;

	validations(): RuleDecl {
		return {
			location: {
				lobbyHours: {
					$each: {
						name: {
							required: requiredIf((model) => {
								return model.value;
							}),
						},
						value: {
							required: requiredIf((model) => {
								return model.name;
							}),
						},
					}
				},
				driveThroughHours: {
					$each: {
						name: {
							required: requiredIf((model) => {
								return model.value;
							}),
						},
						value: {
							required: requiredIf((model) => {
								return model.name;
							}),
						},
					}
				},
				atmHours: {
					$each: {
						name: {
							required: requiredIf((model) => {
								return model.value;
							}),
						},
						value: {
							required: requiredIf((model) => {
								return model.name;
							}),
						},
					}
				},
			}
		};
	}

	isMounted = false;

	mounted(): void {
		this.isMounted = true;
	}

	touch(): void {
		this.$v?.location?.lobbyHours?.$touch();
		this.$v?.location?.driveThroughHours?.$touch();
		this.$v?.location?.atmHours?.$touch();
	}

	reset(): void {
		this.$v?.location?.lobbyHours?.$reset();
		this.$v?.location?.driveThroughHours?.$reset();
		this.$v?.location?.atmHours?.$reset();
	}

	
	get isDirty(): boolean {
		return (
			this.$v?.location?.lobbyHours?.$anyDirty ||
			this.$v?.location?.driveThroughHours?.$anyDirty ||
			this.$v?.location?.lobbyHours?.$anyDirty
		) || false;
	}

	get hasErrors(): boolean {
		if (!this.isMounted) {
			return false;
		}

		return this.lobbyError || this.driveThroughError || this.atmError;
	}

	get lobbyError(): boolean {
		return this.isMounted && this.$v?.location?.lobbyHours?.$anyError || false;
	}
	get driveThroughError(): boolean {
		return this.isMounted && this.$v?.location?.driveThroughHours?.$anyError || false;
	}
	get atmError(): boolean {
		return this.isMounted && this.$v?.location?.atmHours?.$anyError || false;
	}
}
